import { styled } from '../../stitches.config';

export const Image = styled('img', {});
